import React from 'react';
import { format } from 'date-fns';
import { useTheme } from '../contexts/ThemeContext';

const CARA_AUTHOR_ID = '34330632783892';

function CommentBubble({ comment, users }) {
  const { t } = useTheme();
  const authorId = comment.author_id?.toString();
  const isAI = authorId === CARA_AUTHOR_ID;
  const isInternal = !comment.public;
  const user = users?.[authorId];

  const isCustomer = user?.role === 'end-user';
  const authorName = user?.name || (isAI ? 'CARA (AI)' : 'Unknown');

  let accentColor, borderLeftColor, roleLabel;

  if (isInternal) {
    accentColor = '#E5C040';
    borderLeftColor = '#E5C040';
    roleLabel = 'INTERNAL';
  } else if (isAI) {
    accentColor = '#3DD4E8';
    borderLeftColor = '#3DD4E8';
    roleLabel = 'AI';
  } else if (isCustomer) {
    accentColor = t.textMuted;
    borderLeftColor = t.textFaint;
    roleLabel = 'CUSTOMER';
  } else {
    accentColor = '#5B9BF7';
    borderLeftColor = '#5B9BF7';
    roleLabel = 'AGENT';
  }

  const body = comment.plain_body || comment.body || '';
  const timestamp = comment.created_at
    ? format(new Date(comment.created_at), 'MMM d, yyyy h:mm a')
    : '';

  return (
    <div style={{
      borderRadius: '10px',
      borderLeft: `2px solid ${borderLeftColor}`,
      background: t.glass,
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      padding: '14px 16px',
      transition: 'all 0.15s',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '12px', fontWeight: 700, color: accentColor }}>{authorName}</span>
          <span style={{
            fontSize: '8px', fontWeight: 700, textTransform: 'uppercase',
            letterSpacing: '0.1em', color: accentColor, opacity: 0.6,
          }}>{roleLabel}</span>
          {isInternal && (
            <span style={{
              fontSize: '8px', fontWeight: 700, textTransform: 'uppercase',
              letterSpacing: '0.1em',
              background: 'rgba(234, 179, 8, 0.10)', color: '#E5C040',
              padding: '1px 6px', borderRadius: '6px',
            }}>INT</span>
          )}
        </div>
        <span style={{
          fontSize: '10px', color: t.textFaint, fontWeight: 600,
          letterSpacing: '0.02em', fontFamily: "'JetBrains Mono', monospace",
        }}>
          {timestamp}
        </span>
      </div>
      <div
        style={{
          fontSize: '13px', color: t.textSecondary,
          whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.65,
        }}
        dangerouslySetInnerHTML={{
          __html: body.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, ''),
        }}
      />
    </div>
  );
}

export default function ConversationTimeline({ comments, users }) {
  const { t } = useTheme();

  if (!comments?.length) {
    return (
      <div className="card text-center py-8">
        <p style={{
          color: t.textDim, fontSize: '11px', fontWeight: 700,
          letterSpacing: '0.08em', textTransform: 'uppercase',
        }}>
          No conversation data available
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {comments.map((comment, i) => (
        <CommentBubble key={comment.id || i} comment={comment} users={users} />
      ))}
    </div>
  );
}
